var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "regulation-payment-content" }, [
    _c(
      "button",
      {
        staticClass: "regulation-sandbox-close",
        attrs: { title: "Logout" },
        on: { click: _vm.logoutAndExit },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    ),
    _c("div", { staticClass: "regulation-form-content" }, [
      _c("div", { staticClass: "regulation-warning-banner" }, [
        _c("i", { staticClass: "fa-regular fa-triangle-exclamation" }),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("payment_regulation.banner_warning"))),
        ]),
      ]),
      _c("div", { staticClass: "regulation-form-title" }, [
        _vm._v(_vm._s(_vm.$t("payment_regulation.title"))),
      ]),
      _c("div", { staticClass: "regulation-form-subtitle" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("payment_regulation.subtitle_line1")) +
            "\n      "
        ),
        _c("br"),
        _vm._v(_vm._s(_vm.$t("payment_regulation.subtitle_line2")) + "\n    "),
      ]),
      _c("div", { staticClass: "regulation-period" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("payment_regulation.period_label"))),
        ]),
        _c(
          "div",
          { staticClass: "regulation-period-selector" },
          _vm._l(_vm.periodOptions, function (period) {
            return _c(
              "button",
              {
                key: period.value,
                staticClass: "period-btn",
                class: { active: _vm.selectedPeriod === period.value },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.onPeriodClick(period.value)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t(period.labelKey)) +
                    "\n        "
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c("div", { staticClass: "payment-form" }, [
        _c("div", { staticClass: "content-form" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("payment_regulation.payment_label"))),
          ]),
          _c(
            "div",
            {
              staticClass: "card",
              class: [{ open: _vm.methodChoice == "card" }],
            },
            [
              _c(
                "header",
                {
                  on: {
                    click: function ($event) {
                      _vm.methodChoice = "card"
                    },
                  },
                },
                [
                  _vm._m(0),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_card.title"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "fa-brands fa-cc-visa" }),
                  _c("div", { staticClass: "fa-brands fa-cc-mastercard" }),
                ]
              ),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "container-input number-card" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_card.number_card"
                        )
                      )
                    ),
                  ]),
                  _vm._m(1),
                  _c("div", { staticClass: "error" }, [
                    _vm.cardNumberError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.cardNumberError)),
                  ]),
                ]),
                _c("div", { staticClass: "container-input name-card" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "dash.settings.billing.addMethod.method_card.name_card"
                        )
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "input" }, [
                    _c("i", { staticClass: "fa-regular fa-circle-user" }),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.nameCardValue,
                          expression: "nameCardValue",
                        },
                      ],
                      attrs: { placeholder: "ex. John Smith" },
                      domProps: { value: _vm.nameCardValue },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.nameCardValue = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "error" }, [
                    _vm.cardNameError
                      ? _c("i", {
                          staticClass: "fa-regular fa-circle-exclamation",
                        })
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.cardNameError)),
                  ]),
                ]),
                _c("div", { staticClass: "last-line" }, [
                  _c("div", { staticClass: "container-input expire-card" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "dash.settings.billing.addMethod.method_card.expire_card"
                          )
                        )
                      ),
                    ]),
                    _vm._m(2),
                  ]),
                  _c("div", { staticClass: "container-input key-card" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "dash.settings.billing.addMethod.method_card.security_card"
                          )
                        )
                      ),
                    ]),
                    _vm._m(3),
                  ]),
                ]),
                _c("div", { staticClass: "error" }, [
                  _vm.stripeError || _vm.cardExpiryError || _vm.cardCvcError
                    ? _c("i", {
                        staticClass: "fa-regular fa-circle-exclamation",
                      })
                    : _vm._e(),
                  _vm._v(
                    _vm._s(
                      _vm.stripeError || _vm.cardExpiryError || _vm.cardCvcError
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "card",
              class: [{ open: _vm.methodChoice == "paypal" }],
            },
            [
              _c(
                "header",
                {
                  on: {
                    click: function ($event) {
                      _vm.methodChoice = "paypal"
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "circle",
                      class: { active: _vm.methodChoice == "paypal" },
                    },
                    [_c("div")]
                  ),
                  _c("p", [_vm._v("Paypal")]),
                  _c("div", { staticClass: "fa-brands fa-cc-paypal" }),
                ]
              ),
              _vm.methodChoice == "paypal"
                ? _c("div", { staticClass: "content" }, [
                    _c("p", { staticClass: "paypal-info" }, [
                      _vm._v(
                        _vm._s(_vm.$t("payment_regulation.paypal_redirect"))
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "regulation-navigation" }, [
        _c(
          "button",
          {
            staticClass: "regulation-btn regulation-btn-support",
            attrs: { type: "button" },
            on: { click: _vm.contactSupport },
          },
          [
            _c("i", { staticClass: "fa-regular fa-headset" }),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("payment_regulation.contact_support")) +
                "\n      "
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "regulation-btn regulation-btn-submit",
            class: { disabled: !_vm.canSubscribe || _vm.isLoading },
            attrs: {
              type: "button",
              disabled: !_vm.canSubscribe || _vm.isLoading,
            },
            on: { click: _vm.handleSubscribe },
          },
          [
            _vm.isLoading
              ? [_vm._v(_vm._s(_vm.$t("payment_regulation.loading")))]
              : [_vm._v(_vm._s(_vm.$t("payment_regulation.submit_button")))],
          ],
          2
        ),
      ]),
    ]),
    _c("div", { staticClass: "regulation-card-carousel" }, [
      _c("div", { staticClass: "carousel-chosen-label" }, [
        _c("i", { staticClass: "fa-solid fa-chevrons-down" }),
        _c("span", [
          _vm._v(_vm._s(_vm.$t("onboarding.payment.chosen_plan_label"))),
        ]),
        _c("i", { staticClass: "fa-solid fa-chevrons-down" }),
      ]),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedPlanIndex > 0,
              expression: "selectedPlanIndex > 0",
            },
          ],
          staticClass: "carousel-arrow carousel-arrow-left",
          on: { click: _vm.prevPlan },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "10",
                height: "16",
                viewBox: "0 0 10 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M8.5 1L1.5 8L8.5 15",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "carousel-cards-wrapper" },
        _vm._l(_vm.selectablePlans, function (cardPlan, index) {
          return _c(
            "div",
            {
              key: cardPlan.id,
              staticClass: "regulation-card",
              class: {
                "card-active": index === _vm.selectedPlanIndex,
                "card-left": index < _vm.selectedPlanIndex,
                "card-right": index > _vm.selectedPlanIndex,
                "card-near": Math.abs(index - _vm.selectedPlanIndex) === 1,
                "card-far": Math.abs(index - _vm.selectedPlanIndex) >= 2,
              },
              style: _vm.getCardStyle(index),
              on: {
                click: function ($event) {
                  return _vm.selectPlan(index)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "regulation-card-header" },
                [
                  cardPlan.id === "custom"
                    ? [_vm._v(_vm._s(_vm.$t("dash.plan.card.button.contact")))]
                    : cardPlan._planType === _vm.userCurrentPlanType
                    ? [
                        _c("i", { staticClass: "fa-regular fa-rotate-right" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("payment_regulation.current_plan")) +
                            "\n          "
                        ),
                      ]
                    : [
                        _c("i", { staticClass: "fa-regular fa-arrow-up" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("payment_regulation.upgrade_plan")) +
                            "\n          "
                        ),
                      ],
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "regulation-card-body" },
                [
                  cardPlan.id !== "custom"
                    ? [
                        _c("div", { staticClass: "plan-header" }, [
                          _c("h2", [_vm._v(_vm._s(cardPlan.name))]),
                          _vm.getPlanOffer(cardPlan).savingsBadge ||
                          _vm.getPlanOffer(cardPlan).offerText
                            ? _c("div", { staticClass: "offer-container" }, [
                                _vm.getPlanOffer(cardPlan).savingsBadge
                                  ? _c(
                                      "span",
                                      { staticClass: "savings-badge" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t(
                                                _vm.getPlanOffer(cardPlan)
                                                  .savingsBadge
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.getPlanOffer(cardPlan).offerText
                                  ? _c("span", { staticClass: "offer-text" }, [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.getPlanOffer(cardPlan).offerText
                                          ) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "price-display" }, [
                          _c("span", { staticClass: "price" }, [
                            _vm._v(_vm._s(_vm.getPlanPrice(cardPlan)) + "€ "),
                            _c("sup", [
                              _vm._v(
                                _vm._s(_vm.$t("dash.plan.card.tax_label"))
                              ),
                            ]),
                          ]),
                          _c("span", { staticClass: "period" }, [
                            _vm._v(" " + _vm._s(_vm.priceLabel)),
                          ]),
                        ]),
                        _c(
                          "ul",
                          { staticClass: "features-list" },
                          [
                            _c("li", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("dash.plan.card.features.up_to")
                                  ) +
                                  "\n                "
                              ),
                              _c("span", { staticClass: "feature-value" }, [
                                _vm._v(_vm._s(cardPlan.maxSocialAccounts)),
                              ]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "dash.plan.card.features.social_accounts"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _c("li", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("dash.plan.card.features.up_to")
                                  ) +
                                  "\n                "
                              ),
                              _c("span", { staticClass: "feature-value" }, [
                                _vm._v(_vm._s(cardPlan.maxUsers)),
                              ]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("dash.plan.card.features.users")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _c("li", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("dash.plan.card.features.post_from")
                                  ) +
                                  "\n                "
                              ),
                              _c("span", { staticClass: "feature-value" }, [
                                _vm._v(_vm._s(cardPlan.maxSources)),
                              ]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("dash.plan.card.features.sources")
                                  ) +
                                  "\n              "
                              ),
                            ]),
                            _vm._l(
                              _vm.featureKeys,
                              function (featureKey, fIndex) {
                                return _c(
                                  "li",
                                  {
                                    key: fIndex,
                                    class: {
                                      "not-included":
                                        !cardPlan.features[featureKey],
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(_vm.featureLabels[featureKey])
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    : [
                        _c("div", { staticClass: "contact-display" }, [
                          _c("span", { staticClass: "contact-text" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t("dash.plan.card.custom.question")
                                ) +
                                "\n              "
                            ),
                          ]),
                          _c("span", { staticClass: "contact-text" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("dash.plan.card.custom.answer")) +
                                "\n              "
                            ),
                          ]),
                        ]),
                        _c(
                          "ul",
                          { staticClass: "features-list-contact" },
                          [
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("payment_regulation.prefix")) +
                                  " "
                              ),
                              _c("span", { staticClass: "feature-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("payment_regulation.custom_pages")
                                  )
                                ),
                              ]),
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("payment_regulation.prefix")) +
                                  " "
                              ),
                              _c("span", { staticClass: "feature-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("payment_regulation.custom_users")
                                  )
                                ),
                              ]),
                            ]),
                            _c("li", [
                              _vm._v(
                                _vm._s(_vm.$t("payment_regulation.prefix")) +
                                  " "
                              ),
                              _c("span", { staticClass: "feature-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("payment_regulation.custom_sources")
                                  )
                                ),
                              ]),
                            ]),
                            _vm._l(
                              _vm.featureKeys,
                              function (featureKey, fIndex) {
                                return _c("li", { key: fIndex }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(_vm.featureLabels[featureKey])
                                      ) +
                                      "\n              "
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "btn-contact",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.contactSupport.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t("dash.plan.card.button.contact")
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectedPlanIndex < _vm.selectablePlans.length - 1,
              expression: "selectedPlanIndex < selectablePlans.length - 1",
            },
          ],
          staticClass: "carousel-arrow carousel-arrow-right",
          on: { click: _vm.nextPlan },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "10",
                height: "16",
                viewBox: "0 0 10 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M1.5 1L8.5 8L1.5 15",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "carousel-dots" },
        _vm._l(_vm.selectablePlans, function (cardPlan, index) {
          return _c("span", {
            key: "dot-" + cardPlan.id,
            staticClass: "carousel-dot",
            class: { active: index === _vm.selectedPlanIndex },
            on: {
              click: function ($event) {
                return _vm.selectPlan(index)
              },
            },
          })
        }),
        0
      ),
      _c("div", { staticClass: "regulation-downgrade-notice" }, [
        _c("i", { staticClass: "fa-regular fa-circle-info" }),
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("payment_regulation.downgrade_notice")) +
            "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "circle active" }, [_c("div")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-credit-card" }),
      _c("div", {
        staticClass: "inputStripe",
        attrs: { id: "regulation-card-number" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-calendar" }),
      _c("div", {
        staticClass: "inputStripe",
        attrs: { id: "regulation-card-expiry" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input" }, [
      _c("i", { staticClass: "fa-regular fa-key" }),
      _c("div", {
        staticClass: "inputStripe",
        attrs: { id: "regulation-card-cvc" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }